


































































































































import { Component, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix = 'sw-radio';

/**
 * Controlled Radio Form Element
 *
 * @event change
 */
@Component
export default class SwRadio extends SwExtendedVue {
  @Prop({ type: String, required: true })
  name: string;

  @Model('change', { type: String, required: true })
  pickedValue: string;

  @Prop({ type: String, required: true })
  value: string;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: String, default: 'light' })
  theme: 'dark' | 'light';

  cssPrefix = cssPrefix;

  get isChecked(): boolean {
    return this.pickedValue === this.value;
  }

  hasLabel(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.length > 0;
  }

  onInternalValueChange(event: MouseEvent) {
    const toBeChecked = (event.currentTarget as HTMLInputElement).checked;
    /** force it to sync with current state, because its state should fully depend on external input `pickedValue` */
    (event.currentTarget as HTMLInputElement).checked = this.isChecked;
    if (toBeChecked) {
      this.$emit('change', this.value);
    }
  }
}
